import { render, staticRenderFns } from "./app-drawing-tool.vue?vue&type=template&id=165485a2&scoped=true&"
import script from "./app-drawing-tool.vue?vue&type=script&lang=js&"
export * from "./app-drawing-tool.vue?vue&type=script&lang=js&"
import style0 from "./app-drawing-tool.vue?vue&type=style&index=0&id=165485a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165485a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
